<template>
  <div class="doctor-info-container">
    <div>
      <div class="doctor-info-title global-center">完善个人信息</div>
      <div>
        <MeetMenu
          customStyle="padding-left:20px;padding-right:20px;font-size:16px;"
          icon="message.png"
          title="基本信息"
        >
        </MeetMenu>
        <div class="doctor-info-main">
          <div class="doctor-info-block doctor-info-name">
            <div class="doctor-info-key">
              <span
                :class="{
                  'doctor-info-red': !doctorInfo['name'],
                  'doctor-info-main-color': doctorInfo['name'],
                }"
                >*</span
              >姓名
            </div>
            <div class="global-input doctor-info-value">
              <div class="doctor-info-name-block">
                <el-input
                  v-model.trim="doctorInfo.name"
                  placeholder="请输入姓名"
                ></el-input>
                <CustomButton
                  @click="getMatchList"
                  class="doctor-match-button"
                  v-if="doctorInfo.id == 1 || !doctorInfo.id"
                >
                  <img
                    class="doctor-match-icon"
                    :src="require(`@/assets/images/icon/link.png`)"
                    alt=""
                  />
                  匹配
                </CustomButton>
                <div class="global-mask" v-else></div>
                <div class="doctor-match-list" v-if="showDoctorList">
                  <div class="doctor-match-title">
                    {{
                      doctors.length > 0
                        ? "为您匹配到系统中可能是您的信息，请点击确认"
                        : "系统中暂未匹配到您的相关数据，请填写"
                    }}
                  </div>
                  <div class="doctor-match-ul">
                    <div
                      class="doctor-match-li"
                      @click="selectDoctor(item)"
                      v-for="(item, index) in doctors"
                      :key="index"
                    >
                      {{ item.showName }}
                    </div>
                  </div>
                  <div class="doctor-match-close-button">
                    <CustomButton size="small" @click="showDoctorList = false"
                      >关闭</CustomButton
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="doctor-info-block">
            <div class="doctor-info-key">
              <span
                :class="{
                  'doctor-info-red': !doctorInfo['hospital'],
                  'doctor-info-main-color': doctorInfo['hospital'],
                }"
                >*</span
              >医院
            </div>
            <div class="global-input doctor-info-value">
              <el-input
                v-model.trim="doctorInfo.hospital"
                placeholder="请输入医院名称"
              ></el-input>
            </div>
          </div>
          <div class="doctor-info-block">
            <div class="doctor-info-key">
              <span
                :class="{
                  'doctor-info-red': !doctorInfo['department'],
                  'doctor-info-main-color': doctorInfo['department'],
                }"
                >*</span
              >专家科室
            </div>
            <div class="global-input doctor-info-value">
              <el-input
                v-model.trim="doctorInfo.department"
                placeholder="请输入专家科室"
              ></el-input>
            </div>
          </div>

          <div class="doctor-info-block" v-if="isNeedUploadClass()">
            <div class="doctor-info-key">
              <span
                :class="{
                  'doctor-info-red': !doctorInfo['class_url'],
                  'doctor-info-main-color': doctorInfo['class_url'],
                }"
                >*</span
              >课件/病例
            </div>
            <div class="doctor-info-value" @click="selectFile('class_url')">
              <div
                class="doctor-info-class-block"
                :class="{
                  'doctor-info-red': !doctorInfo['class_url'],
                  'doctor-info-main-color': doctorInfo['class_url'],
                }"
              >
                <span v-if="doctorInfo.class_url">{{
                  $tools.getFileName(doctorInfo.class_url)
                }}</span>
                <span v-else>请上传课件/病例</span>
              </div>
            </div>
          </div>
          <div class="doctor-info-block" v-if="isNeedUploadClass()">
            <div class="doctor-info-key">
              <span
                :class="{
                  'doctor-info-red': !doctorInfo['class_name'],
                  'doctor-info-main-color': doctorInfo['class_name'],
                }"
                >*</span
              >课件/病例名
            </div>
            <div class="global-input doctor-info-value">
              <el-input
                v-model.trim="doctorInfo.class_name"
                placeholder="请输入课件/病例名"
              ></el-input>
            </div>
          </div>
          <div class="doctor-info-block">
            <div class="doctor-info-key">
              <span
                :class="{
                  'doctor-info-red': !doctorInfo['professional_cover'],
                  'doctor-info-main-color': doctorInfo['professional_cover'],
                }"
                >*</span
              >简历图片<span>(请上传近期照片，贴合白色轮廓)</span>
            </div>
            <div class="doctor-info-professional-cover-container">
              <div
                class="doctor-info-professional-cover global-center"
                @click="selectFile('professional_cover')"
              >
                <CustomImage
                  :src="doctorInfo.professional_cover"
                  v-if="isShowField('professional_cover')"
                  alt=""
                />
                <img
                  v-else
                  class="doctor-info-frame"
                  :src="require('@/assets/images/icon/header.png')"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="doctor-info-block">
            <div class="doctor-info-key">
              <span
                :class="{
                  'doctor-info-red': !doctorInfo['province'],
                  'doctor-info-main-color': doctorInfo['province'],
                }"
                >*</span
              >省份（示例：湖北）
            </div>
            <div class="global-input global-text-select doctor-info-value">
              <el-select
                v-model="doctorInfo.province"
                placeholder="请选择医生省份"
                @change="changeProvince()"
              >
                <el-option
                  v-for="(item, index) in provinces"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="doctor-info-block">
            <div class="doctor-info-key">
              <span
                :class="{
                  'doctor-info-red': !doctorInfo['city'],
                  'doctor-info-main-color': doctorInfo['city'],
                }"
                >*</span
              >城市（示例：武汉）
            </div>
            <div class="global-input global-text-select doctor-info-value">
              <el-select v-model="doctorInfo.city" placeholder="请选择医生城市">
                <el-option
                  v-for="(item, index) in citys"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="doctor-info-block">
            <div class="doctor-info-key">
              <span
                :class="{
                  'doctor-info-red': !doctorInfo['job'],
                  'doctor-info-main-color': doctorInfo['job'],
                }"
              ></span
              >行政职务
            </div>
            <div class="global-input doctor-info-value">
              <el-input
                v-model.trim="doctorInfo.job"
                placeholder="请输入行政职务"
              ></el-input>
            </div>
          </div>

          <div class="doctor-info-block">
            <div class="doctor-info-key">
              <span
                :class="{
                  'doctor-info-red': !doctorInfo['resume_academic'],
                  'doctor-info-main-color': doctorInfo['resume_academic'],
                }"
                >*</span
              >专家简历/学术任职
              <span>（该内容将用于制作串场幻灯）</span>
            </div>
            <div class="dcotorInfo-textarea global-input doctor-info-value">
              <el-input
                type="textarea"
                :rows="5"
                v-model="doctorInfo.resume_academic"
                placeholder="请输入专家简历/学术任职"
              ></el-input>
            </div>
          </div>
          <div class="doctor-info-block">
            <div class="doctor-info-key">
              <span
                :class="{
                  'doctor-info-red': !doctorInfo['job_name'],
                  'doctor-info-main-color': doctorInfo['job_name'],
                }"
                >*</span
              >专家职称（示例：住院/主治/副主任/主任医师）
              <br />
              <span class="global-color">（{{ getJobTips() }}）</span>
            </div>
            <div class="global-input global-text-select doctor-info-value">
              <el-select
                v-model="doctorInfo.job_name"
                placeholder="请选择专家职称"
              >
                <el-option
                  v-for="(item, index) in config.titles"
                  :disabled="optionIsDisabled(item)"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div
            class="doctor-info-block"
            v-if="doctorInfo.job_name.includes('住院医师')"
          >
            <div class="doctor-info-key">
              上传材料<span class="global-color"
                >(3年以上住院医师方可参与活动，请提供相关证明)</span
              >
            </div>
            <div class="doctor-info-key">3年以上的临床工作经验证明</div>
            <div class="global-text-select doctor-info-value doctor-job-select">
              <div
                class="global-center doctor-info-select"
                v-if="doctorInfo.image_into_job"
                @click="selectFile('image_into_job')"
              >
                <CustomImage :src="doctorInfo.image_into_job"></CustomImage>
              </div>
              <div
                class="global-center doctor-info-select"
                v-else
                @click="selectFile('image_into_job')"
              >
                <img
                  class="doctor-match-icon"
                  :src="require(`@/assets/images/icon/gray-add.png`)"
                  v-if="!isShowUploaded('image_into_job')"
                  alt=""
                />
                <span>上传3年以上的临床工作经验证明</span>
              </div>
            </div>
          </div>
          <div class="doctor-info-block">
            <div class="doctor-info-key">
              <span
                :class="{
                  'doctor-info-red':
                    doctorInfo['professional_prove_img'].length == 0,
                  'doctor-info-main-color':
                    doctorInfo['professional_prove_img'].length,
                }"
                >*</span
              >专家职称证明（可上传1-3张，请务必包含专家姓名、医院、科室、职称信息，否则无法审核通过）
            </div>
            <div class="global-text-select doctor-info-value doctor-job-select">
              <div
                class="doctor-info-audit-status"
                v-if="doctorInfo.work_card_ocr_status === 0"
              >
                职称审核中
              </div>
              <div
                class="doctor-info-audit-status"
                v-if="doctorInfo.work_card_ocr_status === 2"
              >
                人工审核失败，失败原因：{{ doctorInfo.work_card_ocr_reason }}
              </div>

              <div
                class="global-center doctor-info-select"
                v-for="(item, index) in doctorInfo.professional_prove_img"
                :key="item"
                @click="selectFile('professional_prove_img', index)"
              >
                <CustomImage :src="item"></CustomImage>
              </div>
              <div
                class="global-center doctor-info-select"
                v-if="doctorInfo.professional_prove_img.length < 3"
                @click="
                  selectFile(
                    'professional_prove_img',
                    this.doctorInfo.professional_prove_img.length
                  )
                "
              >
                <img
                  class="doctor-match-icon"
                  :src="require(`@/assets/images/icon/gray-add.png`)"
                  alt=""
                />
                <span>点击上传图片</span>
              </div>
            </div>
          </div>
          <div class="doctor-info-block">
            <div class="doctor-info-key">
              <span
                :class="{
                  'doctor-info-red': !doctorInfo['phone'],
                  'doctor-info-main-color': doctorInfo['phone'],
                }"
              ></span
              >手机号码
            </div>
            <div class="global-input doctor-info-value">
              <el-input
                v-model.trim="doctorInfo.phone"
                @input="changeNumber('phone')"
                placeholder="请输入手机号码"
              ></el-input>
            </div>
          </div>
          <div class="doctor-info-block">
            <div class="doctor-info-key">身份证号</div>
            <div class="global-input doctor-info-value">
              <el-input
                v-model.trim="doctorInfo.id_card_number"
                @input="changeIdNumber('id_card_number')"
                placeholder="请输入身份证号"
              ></el-input>
            </div>
          </div>
          <div class="doctor-info-block">
            <div class="doctor-info-key">身份证照片</div>
            <div class="global-text-select doctor-info-value doctor-job-select">
              <div
                class="doctor-info-audit-status"
                v-if="
                  doctorInfo.id_card_front &&
                  doctorInfo.id_card_reverse &&
                  doctorInfo.id_card_ocr_status === 0
                "
              >
                身份证审核中
              </div>
              <div
                class="doctor-info-audit-status"
                v-if="doctorInfo.id_card_ocr_status === 2"
              >
                身份证审核失败，失败原因：{{ doctorInfo.id_card_ocr_reason }}
              </div>

              <div
                :style="IDCardHeight"
                ref="idCardFront"
                class="global-center doctor-info-select"
                v-if="isShowField('id_card_front')"
                @click="selectIDCardWay('id_card_front')"
              >
                <CustomImage :src="doctorInfo.id_card_front"></CustomImage>
              </div>
              <div
                :style="IDCardHeight"
                style="border: none;"
                ref="idCardFront"
                class="global-center doctor-info-select"
                v-else
                @click="selectIDCardWay('id_card_front')"
              >
                <img
                  style="width: 100%; height: 100%;"
                  :src="require(`@/assets/images/expert/front.png`)"
                  v-if="!isShowUploaded('id_card_front')"
                  alt=""
                />
                <span v-if="isShowUploaded('id_card_front')">已上传</span>
              </div>
              <div
                :style="IDCardHeight"
                class="global-center doctor-info-select"
                v-if="isShowField('id_card_reverse')"
                @click="selectIDCardWay('id_card_reverse')"
              >
                <CustomImage :src="doctorInfo.id_card_reverse"></CustomImage>
              </div>
              <div
                :style="IDCardHeight"
                style="border: none;"
                class="global-center doctor-info-select"
                v-else
                @click="selectIDCardWay('id_card_reverse')"
              >
                <img
                  style="width: 100%; height: 100%;"
                  :src="require(`@/assets/images/expert/reverse.png`)"
                  v-if="!isShowUploaded('id_card_reverse')"
                  alt=""
                />
                <span v-if="isShowUploaded('id_card_reverse')">已上传</span>
              </div>
            </div>
          </div>
          <div class="doctor-info-block">
            <div class="doctor-info-key">银行（示例：交通银行）</div>
            <div class="global-input global-text-select doctor-info-value">
              <el-select
                v-model="doctorInfo.bank_name"
                filterable
                allowcreate
                placeholder="请选择银行"
              >
                <el-option
                  v-for="(item, index) in config.banks"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="doctor-info-block">
            <div class="doctor-info-key">开户行所在省份（示例：湖北）</div>
            <div class="global-input global-text-select doctor-info-value">
              <el-select
                v-model="doctorInfo.bank_province"
                placeholder="请选择开户行所在省份"
                @change="changeProvince('bank')"
              >
                <el-option
                  v-for="(item, index) in provinces"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="doctor-info-block">
            <div class="doctor-info-key">开户行所在城市（示例：武汉）</div>
            <div class="global-input global-text-select doctor-info-value">
              <el-select
                v-model="doctorInfo.bank_city"
                placeholder="请选择开户行所在城市"
              >
                <el-option
                  v-for="(item, index) in bankCitys"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="doctor-info-block">
            <div class="doctor-info-key">开户银行（xx支行/xx营业部）</div>
            <div class="global-input doctor-info-value">
              <el-input
                v-model.trim="doctorInfo.bank_name_point"
                placeholder="请输入开户银行"
              ></el-input>
            </div>
          </div>
          <div class="doctor-info-block">
            <div class="doctor-info-key">银行账号</div>
            <div class="global-input doctor-info-value">
              <el-input
                v-model.trim="doctorInfo.bank_number"
                @input="changeNumber('bank_number')"
                placeholder="请输入银行账号"
                clearable
              ></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="doctor-info-block global-center doctor-info-button-group">
      <!-- <CustomButton class="submit" type="info" @click.native="doCancel()" round>
                <img class="doctor-submit-icon" :src="require(`@/assets/images/icon/cancel.png`)" alt="">
                <span>返回</span>
            </CustomButton> -->
      <CustomButton
        class="submit"
        type="info"
        @click.native="deleteDoctor()"
        round
      >
        <!-- <img class="doctor-submit-icon" :src="require(`@/assets/images/icon/submit-doctor.png`)" alt=""> -->

        <el-icon>
          <Delete />
        </el-icon>
        <span>删除专家</span>
      </CustomButton>
      <CustomButton
        class="submit doctor-info-submit"
        type="primary"
        @click.native="doCommit()"
        round
      >
        <img
          class="doctor-submit-icon"
          :src="require(`@/assets/images/icon/submit-doctor.png`)"
          alt=""
        />
        <span>提交信息</span>
      </CustomButton>
    </div>
    <easyCamera v-if="isUploadIDCard" :maskSrc="cameraMask" :photoName="photoName" @doSure="saveIDCard"></easyCamera>
    <image-cropper
      @closeWin="closeWin"
      @receiveData="receiveData"
      ref="imageCropper"
      :CropWidth="getCropperCfg().cropWidth"
      :CropHeight="getCropperCfg().cropHeight"
      :flexScale="getCropperCfg().flexScale"
      :MaxSize="getCropperCfg().MaxSize"
      :isShowHeadimgCalibration="getCropperCfg().isShowHeadimgCalibration"
      :uploadUrl="getCropperCfg().uploadUrl"
      v-if="cropperManager.url && cropperManager.resetFile"
    ></image-cropper>

    <input
      type="file"
      v-show="false"
      v-if="resetFile"
      @change="changeFile"
      ref="selectFile"
    />
  </div>
</template>
<script>
import ItemScroll from "@/components/unit/ItemScroll";
import ImageCropper from "@/components/unit/ImageCropper";
import CustomImage from "@/components/unit/CustomImage.vue";
import CustomButton from "@/components/unit/CustomButton.vue";
import easyCamera from "@/components/unit/easyCamera.vue";
import uploads from "@/common/uploads";
import MeetMenu from "@/components/page/meet/components/menu";
import login from "@/components/page/meet/components/login";
import uploadIdCardExample from "@/components/page/doctor/uploadIdCardExample";
import MyPopup from "@/components/unit/PagePopup.js";
import { Delete } from "@element-plus/icons";
export default {
  name: "doctorInfo",
  mixins: [login,uploadIdCardExample],
  components: {
    ItemScroll,
    ImageCropper,
    CustomButton,
    easyCamera,
    CustomImage,
    Delete,
    MeetMenu,
  },

  data() {
    return {
      config: {
        cropperCfg: {
          professional_cover: {
            cropWidth: 225,
            cropHeight: 225,
            flexScale: [1, 1],
            MaxSize: 2,
            isShowHeadimgCalibration: true,
            uploadUrl: "",
          },
          other: {
            cropWidth: 300,
            cropHeight: 189,
            flexScale: [8.56, 5.4],
            MaxSize: 2,
            isShowHeadimgCalibration: false,
            uploadUrl: "",
          },
        },
        msg: {
          title: "提示",
          hide: true,
          align: "center",
        },
        titles: ["医师（住院医师）", "主治医师", "副主任医师", "主任医师"], // 职称列表
        //主席副高及以上，分享/讨论需要主治医师及以上或3年以上住院医师
        phaseTitle: {
          1: ["副主任医师", "主任医师"],
          2: ["医师（住院医师）", "主治医师", "副主任医师", "主任医师"],
          3: ["医师（住院医师）", "主治医师", "副主任医师", "主任医师"],
          4: ["医师（住院医师）", "主治医师", "副主任医师", "主任医师"],
          5: ["医师（住院医师）", "主治医师", "副主任医师", "主任医师"],
          6: ["副主任医师", "主任医师"],
        },
        JobTips: {
          1: "主席需要副主任医师及以上",
          2: "分享/讨论需要主治医师及以上或3年以上住院医师",
          3: "分享/讨论需要主治医师及以上或3年以上住院医师",
          4: "分享/讨论需要主治医师及以上或3年以上住院医师",
          5: "分享/讨论需要主治医师及以上或3年以上住院医师",
          6: "主席需要副主任医师及以上",
        },
        citys: [],
        hideInfo: {
          phone: [0, -4],
          id_card_number: [0, -6],
          bank_number: [3, -3],
          defaultCfg: [8, -7],
        },
      },
      resetFile: true,
      selectKey: "",
      selectIndex: "",
      cropperManager: {
        key: "",
        url: "",
      },
      hideField: [
        "phone",
        "id_card_number",
        "bank_number",
        "id_card_reverse",
        "id_card_front",
      ],
      doctors: [],
      doctorInfo: {
        id: 0,
        professional_prove_img: [], // 职称资料
        openid: "",
        name: "", // 姓名
        hospital: "", // 医院
        department: "", // 科室
        phone: "", // 手机号
        job_name: "", //职称
        class_url: "", //课件/病例链接
        class_name: "", //课件/病例名
        province: "", // 省份
        city: "", // 城市
        job: "", //行政职务
        resume_academic: "", // 专家简历/学术任职
        professional_cover: "", // 简历图片
        id_card_number: "", // 身份证照片
        bank_province: "", // 银行卡信息
        bank_city: "", // 银行卡城市
        bank_name: "", // 银行
        bank_name_point: "", // 支行
        bank_number: "", // 银行卡号
        id_card_front: "", // 身份证人像面
        id_card_reverse: "", // 身份证国徽面
      },
      loading: false,
      showDoctorList: false,
      jobKeys: [
        "doctor_work_id_card",
        "professional_person",
        "professional_panoramic",
      ],
      notCut: ["professional_prove_img"],
      notImages: ["class_url"],
      query: {},
      IDCardHeight:"",
      cameraMask:"",
      isUploadIDCard:false,
      photoName:"id_card_front.jpg"
    };
  },
  async created() {
    this.query = this.$tools.getStorage("doctor-query") || this.$route.query;
    this.saveQuery();
    this.config.citys = await this.$tools.getCityConfig();
    this.config.banks = await this.$tools.getBankConfig();
  },
  beforeUnmount() {
    this.$tools.setStorage("doctor-query", "");
  },
  mounted() {
    this.login()
      .then(() => {
        this.id = this.query.id || "";
        if (this.id) {
          this.loadDoctorInfo();
        } else {
          this.doctorInfo = {
            ...this.doctorInfo,
            ...this.query,
          };
        }
      })
      .catch((err) => {
        this.$router.back();
      });
      this.getIDCardHeight();
  },
  computed: {
    provinces() {
      return this.config.citys.map((item) => item.name);
    },
    citys() {
      if (!this.doctorInfo.province) return [];
      let index = this.provinces.indexOf(this.doctorInfo.province);
      if (index == -1) return [];
      return this.config.citys[index].sub.map((item) => item.name);
    },
    bankCitys() {
      if (!this.doctorInfo.bank_province) return [];
      let index = this.provinces.indexOf(this.doctorInfo.bank_province);
      if (index == -1) return [];
      return this.config.citys[index].sub.map((item) => item.name);
    },
  },
  methods: {
    getIDCardHeight(){
      const height = this.$tools.getIDCardHeight(this.$refs.idCardFront.clientWidth)
      this.IDCardHeight = `height: ${height}px`;
    },
    async loadDoctorInfo() {
      let url = this.$tools.getURL(this.$urls.doctor.info, { ...this.query });
      this.$axios
        .get(url)
        .then((res) => {
          console.log(url);
          this.doctorInfo = {
            ...res.data,
            ...this.query,
            professional_prove_img: (res.data.professional_prove_img || "")
              .split(",")
              .filter((x) => x),
          };
          this.hideData();
          console.log(this.$tools.verifyDoctorInfo(this.doctorInfo));
          this.initScroll();
        })
        .catch(() => {});
    },
    getJobTips() {
      let phase = this.$route.query.phase ? Number(this.$route.query.phase) : 0;
      return this.config.JobTips[phase];
    },
    optionIsDisabled(item) {
      let phase = this.$route.query.phase
        ? Number(this.$route.query.phase)
        : "";
      if (!phase) {
        return false;
      }
      return !this.config.phaseTitle[phase].includes(item);
    },
    initJobImg(data) {
      let images = [];
      this.jobKeys.forEach((key) => {
        images = images.concat(data[key]);
      });
      images = images.concat((data.professional_prove_img || "").split(","));
      images = images.filter((x) => x);
      this.doctorInfo.professional_prove_img = images;
    },
    isNeedUploadClass() {
      return Number(this.query.need_class);
    },
    isShowField(key) {
      return this.doctorInfo[key] && !this.doctorInfo[key].includes("*");
    },
    isShowUploaded(key) {
      return this.doctorInfo[key] && this.doctorInfo[key].includes("*");
    },
    changeIdNumber(key) {
      this.doctorInfo[key] = this.doctorInfo[key].replace(/[^\dxX*]/g, "");
    },
    changeNumber(key) {
      this.doctorInfo[key] = this.doctorInfo[key].replace(/[^\d*]/g, "");
    },
    changeProvince(key) {
      if (key == "bank") {
        this.doctorInfo.bank_city = "";
      } else {
        this.doctorInfo.city = "";
      }
    },

    //数据脱敏
    hideData() {
      for (let key of this.hideField) {
        this.doctorInfo[key] = this.doctorInfo[key] || "";
        if (!this.doctorInfo[key]) continue;
        let cfg = this.config.hideInfo[key] || this.config.hideInfo.defaultCfg;
        this.doctorInfo[key] = `${this.doctorInfo[key].slice(
          0,
          cfg[0]
        )}****${this.doctorInfo[key].slice(cfg[1])}`;
      }
    },
    getShowName(key, label) {
      return this.doctorInfo[key] ? "已上传" : label;
    },
    saveQuery() {
      this.$tools.setStorage("doctor-query", this.query);
    },
    selectIDCardWay(key){
      this.selectUploadIdCardWay(key).then(() => {
        //相机拍摄
        this.takeIDCard(key);
      }).catch((res)=>{
        if(res)return
        //相册选择
        if(key == "id_card_front"){
          this.frontIdCardExample().then(() => {
              this.selectFile(key)
            }).catch((err) => {
              this.selectFile(key)
          });
        }
        if(key == "id_card_reverse"){
          this.reverseIdCardExample().then(() => {
              this.selectFile(key)
            }).catch((err) => {
              this.selectFile(key)
          });
        }
      })
    },
    takeIDCard(key){
      this.selectKey = key;
      this.selectIndex = undefined;
      if(key == "id_card_front"){
        this.cameraMask = require('@/assets/images/camera/front.png');
        this.photoName = "id_card_front.jpg";
        this.$nextTick(() => {
          this.isUploadIDCard=true
        })
      }
      if(key == "id_card_reverse"){
        this.cameraMask=require('@/assets/images/camera/reverse.png');
        this.photoName = "id_card_reverse.jpg";
        this.$nextTick(() => {
          this.isUploadIDCard=true
        })
      }
    },
    saveIDCard(url){
      if(url){
        this.saveFileURL(url);
      }
      this.isUploadIDCard=false;
    },
    selectFile(key, index = undefined) {
      if (key == "class_url") {
        if (!this.doctorInfo.name) {
          this.$tips.error({ text: "请先输入专家姓名" });
          return;
        }
        if (!this.doctorInfo.hospital) {
          this.$tips.error({ text: "请先输入医院" });
          return;
        }
        if (!this.doctorInfo.department) {
          this.$tips.error({ text: "请先输入科室" });
          return;
        }
      }
      this.selectKey = key;
      this.selectIndex = index;
      this.$refs.selectFile.click();
    },
    getCropperCfg() {
      let key =
        this.selectKey == "professional_cover" ? "professional_cover" : "other";
      return this.config.cropperCfg[key];
    },
    async uploadFile(file) {
      let result = "";
      try {
        let img = await this.$tools.compressImage(file, true);
        let result = await uploads.uploadBase64({
          file: img,
          item: { type: "job" },
        });
        return result;
      } catch (err) {
        // 压缩失败
        let res = await uploads.uploadFile({
          file,
          key: "files",
          item: { type: "job" },
        });
        result = res.data[0];
        return result;
      }
    },
    async changeFile(event) {
      let file = event.target.files[0];
      if (!file) return;
      this.resetFile = false;
      this.$nextTick(() => {
        this.resetFile = true;
      });
      let loading = this.$tips.loading({ text: "上传中..." });
      // 处理非图片
      console.log(
        this.notImages.includes(this.selectKey),
        this.selectKey,
        this.notImages
      );
      if (this.notImages.includes(this.selectKey)) {
        await this.dealWithNotImage(file);
        loading.close();
        return;
      }
      // 处理图片
      let reg = "jpg|jpeg|png|PNG|JPG|JPEG";
      let RegObj = new RegExp(`^(${reg})$`);
      let type = file.name.split(".").slice(-1);
      if (!RegObj.test(type)) {
        this.$tips.error({ text: `类型必须是${reg.replace(/\|/g, ",")}` });
        loading.close();
        return "";
      }
      // 处理不需要剪切的
      if (this.notCut.includes(this.selectKey)) {
        await this.dealWithNotCutImage(file);
      } else {
        await this.dealWithCutImage(file);
      }
      loading.close();
    },
    async dealWithNotCutImage(file) {
      let url = await this.uploadFile(file);
      this.saveFileURL(url);
    },
    async dealWithNotImage(file) {
      let className = "",
        item = {};
      if (this.$route.query.phase == 2) {
        className = file.name.split(".").slice(0, -1).join(".");
      } else {
        className = file.name.split(".").slice(0, -1).join(".");
        // className = this.getClassFileName()
        // item.fileName = className
      }
      let res = await uploads.uploadFile({
        file,
        type: "",
        reg: "",
        key: "files",
        item: { type: "couseware", ...item },
      });

      this.doctorInfo.class_name = className;
      this.doctorInfo[this.selectKey] = res.data[0];
    },
    getClassFileName() {
      return `${this.doctorInfo.name}-${this.doctorInfo.hospital}-${this.doctorInfo.department}-病例`;
    },
    async dealWithCutImage(file) {
      let fileInfo = await this.$tools.compressImage(file, true);
      this.cropperManager.resetFile = false;
      this.cropperManager.url = fileInfo;
      this.$nextTick(() => {
        this.cropperManager.resetFile = true;
        this.$nextTick(() => {
          this.$refs.imageCropper.setData(this.cropperManager.url);
        });
      });
    },
    receiveData(data) {
      this.saveFileURL(data.url);
      this.cropperManager.url = "";
    },
    closeWin() {
      this.cropperManager.url = "";
      this.cropperManager.resetFile = true;
    },
    saveFileURL(url) {
      if (this.selectIndex !== undefined) {
        this.doctorInfo[this.selectKey][this.selectIndex] = url;
      } else {
        this.doctorInfo[this.selectKey] = url;
      }
    },
    checkData() {
      if (!this.doctorInfo.name) {
        this.$tips.error({ text: "请输入姓名" });
        return false;
      }
      if (this.doctorInfo.name.includes("待定")) {
        console.log("待定");
        this.$tips.error({ text: "专家姓名不能是待定" });
        return false;
      }
      if (!this.doctorInfo.hospital) {
        this.$tips.error({ text: "请输入医院" });
        return false;
      }
      if (!this.doctorInfo.department) {
        this.$tips.error({ text: "请输入专家科室" });
        return false;
      }
      if (!this.doctorInfo.phone.includes("*")) {
        // if (!this.doctorInfo.phone) {
        //   this.$tips.error({ text: "请输入手机号" });
        //   return false;
        // }
        if (
          this.doctorInfo.phone &&
          !/^1[3-9]\d{9}$/.test(this.doctorInfo.phone)
        ) {
          this.$tips.error({ text: "请输入格式正确的手机号" });
          return false;
        }
      }
      // if (this.isNeedUploadClass() && !this.doctorInfo.class_url) {
      //     this.$tips.error({ text: "请上传课件/病例" });
      //     return false;
      // }
      if (!this.doctorInfo.professional_cover) {
        this.$tips.error({ text: "请上传简历图片" });
        return false;
      }
      if (!this.doctorInfo.province) {
        this.$tips.error({ text: "请选择医生省份" });
        return false;
      }
      if (!this.doctorInfo.city) {
        this.$tips.error({ text: "请选择医生城市" });
        return false;
      }

      // if (!this.doctorInfo.job) {
      //   this.$tips.error({ text: "请输入行政职务" });
      //   return false;
      // }
      if (!this.doctorInfo.resume_academic) {
        this.$tips.error({ text: "请输入专家简历/学术任职" });
        return false;
      }
      if (this.doctorInfo.resume_academic.length < 10) {
        this.$tips.error({ text: "专家简历/学术任职最少十个字" });
        return false;
      }
      if (!this.doctorInfo.job_name) {
        this.$tips.error({ text: "请选择职称" });
        return false;
      }
      //住院医师需要上传3年以上的临床工作经验证明
      if (
        this.doctorInfo.job_name.includes("住院医师") &&
        !this.doctorInfo.image_into_job
      ) {
        this.$tips.error({ text: "请上传3年以上的临床工作经验证明" });
        return false;
      }
      if (this.doctorInfo.professional_prove_img.length == 0) {
        this.$tips.error({ text: "请上传职称资料" });
        return false;
      }
      if (
        !this.doctorInfo.id_card_number.includes("*") &&
        this.doctorInfo.id_card_number &&
        !/^\d{17}[\dxX]{1}$/g.test(this.doctorInfo.id_card_number)
      ) {
        this.$tips.error({ text: "请输入格式正确的身份证号" });
        return false;
      }
      if (
        !this.doctorInfo.bank_number.includes("*") &&
        this.doctorInfo.bank_number &&
        !/^\d{14,22}$/.test(this.doctorInfo.bank_number)
      ) {
        this.$tips.error({ text: "请输入正确的银行账号" });
        return false;
      }
      return true;
    },

    isHide(data) {
      return (String(data) || "").includes("*");
    },
    doCancel() {
      this.$router.back();
    },
    deleteDoctor() {
      if (this.loading) return;
      this.loading = true;
      MyPopup({
        content: [
          `您确定要删除此会议的专家<span style='color:red'>${this.doctorInfo.name}</span>吗`,
        ],
      })
        .then((res) => {
          let loading = this.$tips.loading({ text: "..." });
          let data = { ...this.query };
          data.doctor_id = data.id;
          this.$axios
            .patch(this.$urls.doctor.delete, data)
            .then((res) => {
              this.$tips.success({ text: "删除成功" });
              this.doCancel();
              setTimeout(() => {
                loading.close();
                this.loading = false;
              }, 1000);
            })
            .catch(() => {
              setTimeout(() => {
                loading.close();
                this.loading = false;
                if (!this.query.id) {
                  this.$router.back();
                }
              }, 1000);
            });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    formatInfo() {
      let data = { ...this.doctorInfo };
      for (let key in data) {
        if (data[key] === null) data[key] = "";
      }
      data.professional_prove_img = data.professional_prove_img.join(",");
      return data;
    },
    //提交医生信息
    doCommit() {
      if (!this.checkData() || this.loading) return;
      this.loading = true;
      let loading = this.$tips.loading({ text: "信息保存中..." });
      this.$axios
        .patch(this.$urls.doctor.info, this.formatInfo())
        .then((res) => {
          setTimeout(() => {
            this.doctorInfo = {
              ...this.doctorInfo,
              ...res.data,
              id: res.data.doctor_id,
            };
            this.query = {
              ...this.query,
              ...res.data,
              id: res.data.doctor_id,
            };
            this.saveQuery();
            switch (res.code) {
              case 2002:
                this.doctorInfo.work_card_ocr_status = 0;
                MyPopup({
                  content: [
                    "职称证明<span style='color:red'>系统审核失败</span>，请检查<span style='color:red'>姓名</span>、<span style='color:red'>医院</span>、<span style='color:red'>科室</span>、<span style='color:red'>职称</span>文字信息是否与图片一致，确认后<span style='color:red'>重新上传</span>职称证明或者等待<span style='color:red'>人工审核通过</span>",
                  ],
                })
                  .then((res) => {
                    this.$router.push({
                      path: "/meetInfo",
                      query: {
                        id: this.$route.query.meet_id,
                      },
                    });
                  })
                  .catch((err) => {});
                break;
              case 2001:
                this.$tips.error({ text: res.msg });
                break;
              default:
                this.$tips.success({ text: "修改成功" });
                if (this.$route.come_from == 2) {
                  // 跳转协议页面
                  // this.$route.push
                } else {
                  this.$router.back();
                }
            }
            loading.close();
            this.loading = false;
          }, 1000);
        })
        .catch(() => {
          setTimeout(() => {
            loading.close();
            this.loading = false;
          }, 1000);
        });
    },
    selectDoctor(doctor) {
      delete doctor.id;
      this.doctorInfo = {
        ...this.doctorInfo,
        ...doctor,
      };
      this.initJobImg(doctor);
      // this.hideData();
      this.showDoctorList = false;
    },
    //匹配基本信息
    getMatchList() {
      if (this.isMatching) return;
      if (!this.doctorInfo.name) {
        this.$tips.error({ text: "请输入姓名之后再匹配" });
        return;
      }
      this.isMatching = true;
      let loading = this.$tips.loading({ text: "匹配中..." });
      let url = this.$tools.getURL(this.$urls.doctor.match, {
        name: this.doctorInfo.name,
      });
      this.$axios
        .get(url)
        .then((res) => {
          setTimeout(() => {
            this.isMatching = false;
          }, 1000);
          loading.close();
          this.doctors = [...res.data].map((doctor) => {
            doctor.showName = `${doctor.name}-${doctor.hospital}`;
            return doctor;
          });
          this.showDoctorList = true;
        })
        .catch((err) => {
          setTimeout(() => {
            this.isMatching = false;
          }, 1000);
          loading.close();
        });
    },
  },
};
</script>
<style>
.doctor-info-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;
  overflow: auto;
  background: #fff;
}

.doctor-info-title {
  height: 33px;
  background: var(--el-color-primary);
  font-weight: 700;
  font-size: 16px;
  color: #fff;
}

.doctor-info-main {
  padding: 0 20px;
}

.doctor-info-block {
  margin-bottom: 15px;
  width: 100%;
}

.doctor-info-block .el-button {
  width: 100%;
}

.doctor-info-id-card-type .global-input {
  padding: 0 1rem;
}

.doctor-info-key {
  font-weight: 700;
  font-size: 14px;
  color: #221815;
  line-height: 20px;
}

.doctor-info-key span {
  /* color: #000; */
}

.doctor-info-value {
  margin-top: 8px;
  height: auto;
  /* padding-right: 0.5rem; */
  display: flex;
  justify-content: space-between;
  color: #6a6266;
  word-break: break-all;
  position: relative;
}

.doctor-match-button {
  height: 23px;
  width: 91px;
  font-size: 13px;
  margin-right: 7px;
}

.doctor-match-icon {
  width: 13px;
  height: 13px;
  margin-right: 7px;
  margin-bottom: 2px;
}

.doctor-match-list {
  width: 100%;
  height: auto;
  position: absolute;
  right: 0;
  top: 45px;
  background: #fff;
  z-index: 1000;
  padding: 10px 10px 0;
  border: 1px solid #e5e5e5;
}

.doctor-match-title {
  color: var(--el-color-primary);
  font-size: 13px;
}

.doctor-match-list::before {
  content: "";
  width: 0;
  height: 0;
  border-width: 5px;
  border-color: transparent transparent #fff transparent;
  border-style: solid;
  position: absolute;
  right: 30px;
  top: -10px;
  z-index: 1001;
}

.doctor-match-ul {
  max-height: 80px;
  overflow: scroll;
}

.doctor-match-li {
  height: 20px;
  line-height: 20px;
  font-size: 13px;
}

.doctor-match-close-button {
  padding: 15px 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.doctor-match-close-button {
  width: 100%;
  height: 20px;
}

.doctor-match-close-button .customButton_container {
  width: 60px;
  font-size: 13px;
}

.doctor-info-container .customButton_small {
  margin-top: 10px;
  width: auto;
  font-size: 13px;
}

.doctor-info-container .el-textarea--inner {
  overflow: auto;
}

.doctor-info-professional-cover {
  width: 109px;
  height: 109px;
  background: #e5e5e5;
}

.doctor-info-professional-cover img {
  width: 77px;
  height: auto;
}

.doctor-info-professional-cover-container {
  margin-top: 8px;
}

.doctor-job-select {
  display: flex;
  flex-direction: column;
}

.doctor-info-select {
  border: 1px solid #e5e5e5;
  color: #9fa0a0;
  font-size: 13px;
  flex-direction: column;
  width: 100%;
  height: 134px;
  margin-bottom: 10px;
}

.doctor-info-select span {
  margin-top: 8px;
}

.doctor-info-select img {
  height: 18px;
  width: auto;
}

.doctor-submit-icon {
  height: 15px;
  width: auto;
  position: relative;
  z-index: 99999;
  margin-right: 6px;
  margin-top: -1px;
}

.doctor-info-submit {
  margin-left: 10px;
}

.doctor-info-class-block {
  font-size: 13px;
  text-decoration: underline;
  color: #c00000;
  /* color: var(--el-color-primary) */
}

/* .doctor-info-class-block span:last-child{
    margin-left:10px;
} */
.doctor-info-audit-status {
  font-size: 13px;
  color: #c00000;
  margin-bottom: 5px;
}
.doctor-info-red {
  color: #c00000;
}
.doctor-info-main-color {
  color: var(--el-color-primary);
}

.doctor-info-button-group {
  padding: 0 20px;
}
.doctor-info-name-block {
  display: flex;
  align-items: center;
  width: 100%;
}
.doctor-info-name-disabled {
  background: rgba(159, 160, 160, 0.1);
  font-size: 13px;
}
</style>